const doc = [({"ko":({"adminConstantDayOfWeekShort":({"friday":"금", "monday":"월", "saturday":"토", "sunday":"일", "thursday":"목", "tuesday":"화", "wednesday":"물"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;